import {BugBicStage, resolveStage} from '@buildinginformationcloud/bug-bic';

/**
 * Die bugBIC-Widget-Instanz je Umgebung.
 *
 * Beta und Live sollen in getrennte Instanzen melden, damit Tickets aus einem
 * Beta-Test nicht zwischen echten Kundenmeldungen landen. Die Zuordnung haengt
 * bewusst an der Stage, die das Widget zur Laufzeit aus dem Hostnamen ableitet,
 * und *nicht* an `environment.production`:
 *
 * Beta baut die Angular-Config `development` (siehe Dockerfile.frontend.beta),
 * Live die Config `production`. Ueber die environment-Dateien zu gehen wuerde
 * heute zwar funktionieren, aber genau in dem Moment still umkippen, in dem
 * jemand den Beta-Build auf eine Production-Config umstellt - eine naheliegende
 * Aufraeumaktion, nach der Beta-Meldungen unbemerkt in die Live-Instanz liefen.
 * Der Hostname luegt dagegen nicht.
 */

/** Instanz fuer alles, was nicht Live ist. */
const INSTANCE_BETA = '3348e2cb-4ecf-4283-8237-dde31f86ffbc';

/**
 * Instanz fuer Live.
 */
const INSTANCE_LIVE = '39848dcb-71bd-420f-b928-2e008e56f425';

/**
 * Vollstaendig, nicht partiell: `Record` erzwingt einen Eintrag pro Stage. Kommt
 * im Widget eine neue Umgebung dazu, bricht hier der Build, statt dass Reports
 * aus ihr stillschweigend in der falschen Instanz landen.
 */
const INSTANCE_BY_STAGE: Record<BugBicStage, string> = {
  live: INSTANCE_LIVE,
  beta: INSTANCE_BETA,
  dev: INSTANCE_BETA,
  preview: INSTANCE_BETA,
  // Eine unbekannte Domain ist im Zweifel keine Live-Umgebung: lieber eine
  // Meldung zu viel in der Beta-Instanz als eine falsche zwischen den echten.
  unknown: INSTANCE_BETA,
};

/** Die Widget-Instanz, in die diese Umgebung ihre Bug-Reports meldet. */
export function bugBicInstanceId(): string {
  return INSTANCE_BY_STAGE[resolveStage()];
}
